(() => {
  if (window.__rfFinishLabelFix) return;
  window.__rfFinishLabelFix = true;
  const normalizeFinish = (value) => (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[-_/()]/g, ' ').replace(/\s+/g, ' ').trim();
  const getFinishFieldset = (root) => [...root.querySelectorAll('fieldset')].find((fieldset) => {
    const text = normalizeFinish(fieldset.querySelector('legend')?.textContent);
    return text.includes('finition') || text.includes('finish') || text.includes('acabado');
  });
  const getLabel = (fieldset, input) => {
    if (!fieldset || !input || !input.id) return null;
    return fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
  };
  const renderFinish = (guide, value, reopen) => {
    if (!guide) return;
    const key = normalizeFinish(value);
    const record = [...guide.querySelectorAll('.rf-finish__data')].find((item) => {
      const match = normalizeFinish(item.dataset.match);
      return key.includes(match) || match.includes(key);
    });
    if (!record) return;
    const panel = guide.querySelector('.rf-finish__panel');
    const image = guide.querySelector('.rf-finish__image');
    const title = guide.querySelector('.rf-finish__title');
    const description = guide.querySelector('.rf-finish__description');
    const benefits = guide.querySelector('.rf-finish__benefits');
    if (panel) panel.classList.add('is-changing');
    if (image) { image.src = record.dataset.src; image.alt = record.dataset.alt; }
    if (title) title.textContent = record.dataset.title;
    if (description) description.textContent = record.dataset.description;
    if (benefits) {
      benefits.replaceChildren(...record.dataset.benefits.split('|').map((text) => {
        const item = document.createElement('li');
        item.textContent = text;
        return item;
      }));
    }
    if (reopen) guide.classList.remove('is-collapsed');
    window.setTimeout(() => { if (panel) panel.classList.remove('is-changing'); }, 180);
  };
  const syncFinishes = (root) => {
    (root || document).querySelectorAll('.main-product-variant-picker').forEach((picker) => {
      const variants = picker.querySelector('variant-input.product-variants-js');
      const guide = picker.querySelector('[data-rf-finish-guide]');
      if (!variants || !guide) return;
      const fieldset = getFinishFieldset(variants);
      if (!fieldset) return;
      fieldset.classList.add('rf-finish-fieldset');
      if (variants.firstElementChild !== fieldset) variants.prepend(fieldset);
      if (guide.parentElement !== variants || guide.previousElementSibling !== fieldset) fieldset.after(guide);
      const selected = [...fieldset.querySelectorAll('input')].find((input) => input.checked);
      const selectedLabel = getLabel(fieldset, selected);
      if (selectedLabel) renderFinish(guide, selectedLabel.textContent, false);
      fieldset.querySelectorAll('input').forEach((input) => {
        const label = getLabel(fieldset, input);
        if (label) label.classList.toggle('is-selected', input.checked);
      });
    });
  };
  document.addEventListener('click', (event) => {
    const label = event.target.closest('label');
    const fieldset = label?.closest('fieldset');
    if (!label || !fieldset) return;
    const legend = normalizeFinish(fieldset.querySelector('legend')?.textContent);
    if (!legend.includes('finition') && !legend.includes('finish') && !legend.includes('acabado')) return;
    renderFinish(fieldset.parentElement?.querySelector('[data-rf-finish-guide]'), label.textContent, true);
    window.setTimeout(() => syncFinishes(fieldset.closest('.main-product-variant-picker') || document), 80);
  }, true);
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('input')) return;
    const fieldset = input.closest('fieldset');
    const label = getLabel(fieldset, input);
    const legend = normalizeFinish(fieldset?.querySelector('legend')?.textContent);
    if (!label || (!legend.includes('finition') && !legend.includes('finish') && !legend.includes('acabado'))) return;
    renderFinish(fieldset.parentElement?.querySelector('[data-rf-finish-guide]'), label.textContent, true);
    window.setTimeout(() => syncFinishes(fieldset.closest('.main-product-variant-picker') || document), 80);
  }, true);
  const init = () => syncFinishes(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.setTimeout(init, 400);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
